import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { installBrowserPreloadRecovery, registerServiceWorker } from '@/lib/app-version';
import '@/index.css';

// A chunk the running bundle names can fail to load once a newer deployment
// is live; reload once. Then register the worker the deployment watcher
// updates (src/lib/app-version).
installBrowserPreloadRecovery();
registerServiceWorker();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
